import React from 'react';
import { AddressAutocompleteMatch } from '../../../types/AddressValidation';
import PoweredByGoogle from '../../content/PoweredByGoogle';
import AutocompleteMatch from '../AutocompleteMatch';

export const AutocompleteMatchListTestId = 'AutocompleteMatchList-input';

export type AutocompleteMatchListProps = {
  matches: AddressAutocompleteMatch[];
  onMatchSelect: (placeId: string) => Promise<void>;
};

const AutocompleteMatchList: React.FC<AutocompleteMatchListProps> = ({
  matches,
  onMatchSelect,
}: AutocompleteMatchListProps) => {
  if (matches.length) {
    return (
      <div
        className="flex flex-col space-y-3 mx-3 my-4"
        data-testid={AutocompleteMatchListTestId}
      >
        {matches.map(match => {
          return (
            <AutocompleteMatch
              key={match.placeId}
              description={match.description}
              onClick={(): Promise<void> => onMatchSelect(match.placeId)}
            />
          );
        })}
        <div className="flex flex-row justify-end">
          <PoweredByGoogle />
        </div>
      </div>
    );
  }
  return null;
};

export default AutocompleteMatchList;
